import PropTypes from 'prop-types';
import Instruction from './Instruction';

const Instructions = (props) => {
  const { hiddenInstructionProfile, isModal, loading, instructionsProfile, instructionsSite } = props;

  if (loading || (!instructionsSite && !instructionsProfile)) {
    return;
  }

  return (
    <>
      <Instruction data={instructionsSite} isModal={isModal} title="Consignes du site" />
      {!hiddenInstructionProfile && (
        <Instruction data={instructionsProfile} isModal={isModal} title="Consignes du profil" />
      )}
    </>
  );
};

Instructions.propTypes = {
  hiddenInstructionProfile: PropTypes.bool,
  isModal: PropTypes.bool,
  loading: PropTypes.bool,
  instructionsProfile: PropTypes.string,
  instructionsSite: PropTypes.string
};

export default Instructions;
